<h1 mat-dialog-title>Choose a Contract</h1>

<mat-dialog-content>
  <contract-select
    [headerText]="headerText"
    [contracts]="contracts"
    [shouldAllowSearching]="false"
    [shouldDisableWeDate]="true"
    [hasEmbeddedComponent]="true"
    (next)="close($event)"
    (backClicked)="close()"
  />
</mat-dialog-content>
